import React, { useState } from 'react';
import { bool, number, shape, string } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Col, Row, Heading } from '@thd-olt-component-react/core-ui';
import {
  StoreSearch,
  SearchInput,
  Map,
  Results
} from '@thd-olt-component-react/store-search';
import './nearbyStores.scss';

export const NearbyStores = ({
  isMobile,
  mapOptions,
  pageType,
  resultsOptions,
  storeNumber,
  title
}) => {
  const [searchInput, setSearchInput] = useState(storeNumber);
  const setSearchInputHandler = (value) => {
    setSearchInput(value);
  };

  const getLinkType = () => {
    switch (pageType) {
    case 'rentals':
      return 'rentals'
    case 'services':
      return 'services'
    default:
      return 'store'
    }
  }

  const getPhoneNumberType = () => {
    switch (pageType) {
    case 'rentals':
      return 'tool'
    case 'services':
      return 'services'
    default:
      return null
    }
  }

  const linkType = getLinkType();
  const phoneNumberType = getPhoneNumberType();

  return (
    <>
      {!isMobile ? (
        <Row>
          <Col fallback={12}>
            <Heading title={title} underline />
            <StoreSearch
              searchInput={storeNumber}
              pageSize={10}
            >
              <Col className="nearby-stores__map" nopadding sm="9" xs="7">
                <Map
                  classNameForStoreMap="nearby-stores__store-map"
                  mapOptions={mapOptions}
                />
              </Col>
              <Col nopadding sm="3" xs="5">
                <Results
                  className="nearby-stores__results"
                  disableScroll
                  disableAccordion
                  linkType={linkType}
                  maxNumberOfResults={resultsOptions.maxNumberOfResults}
                  omitStoreNumber={resultsOptions.omitStoreNumber}
                  phoneNumberType={phoneNumberType}
                />
              </Col>
            </StoreSearch>
          </Col>
        </Row>
      ) : (
        <Row className="nearby-stores__store-search">
          <Col>
            <Heading title={title} underline />
          </Col>
          <Col fallback={12}>
            <StoreSearch
              searchInput={searchInput}
              setSearchInput={setSearchInputHandler}
              pageSize={4}
            >
              <Results
                disableScroll
                disableAccordion
                linkType={linkType}
                maxNumberOfResults={resultsOptions.maxNumberOfResults}
                omitStoreNumber={resultsOptions.omitStoreNumber}
                phoneNumberType={phoneNumberType}
              />
              <SearchInput hideUseCurrentLocation className="nearby-stores__store-search-input" />
            </StoreSearch>
          </Col>
        </Row>
      )}
    </>
  );
};

NearbyStores.defaultProps = {
  mapOptions: {
    disableOnMapViewChange: true,
    disableOnStoreClick: true,
    height: '459px',
    omitStoreNumber: '0'
  },
  pageType: 'store',
  resultsOptions: {
    maxNumberOfResults: 3,
    omitStoreNumber: '0'
  },
  title: 'Nearby Stores'
}

NearbyStores.propTypes = {
  isMobile: bool.isRequired,
  mapOptions: shape({
    disableOnMapViewChange: bool,
    disableOnStoreClick: bool,
    height: string,
    omitStoreNumber: string
  }),
  pageType: string,
  resultsOptions: shape({
    maxNumberOfResults: number,
    omitStoreNumber: string
  }),
  storeNumber: string.isRequired,
  title: string
}

NearbyStores.dataModel = extend({}, StoreSearch);

export default NearbyStores
